module.exports = __webpack_public_path__ + "joy-static/media/Snowman.4331606b.png";